'use client';

import useSWR from "swr";

const fetcher = async <T>(url: string): Promise<T> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 20000); // 20-second timeout

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${process.env.NEXT_PUBLIC_TOKEN}`,
      },
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data. Please try again later.");
  } finally {
    clearTimeout(timeoutId);
  }
};

interface Post {
  id: number;
  url_en: string;
  url_ar: string;
  url_fr: string;
  url_kab: string | null;
  image: string | null;
  tag_en: string | null;
  tag_ar: string | null;
  tag_fr: string | null;
  tag_kab: string | null;
  title_en: string;
  title_ar: string;
  title_fr: string;
  title_kab: string | null;
  description_en: string;
  description_ar: string;
  description_fr: string;
  description_kab: string | null;
  content_en: string;
  content_ar: string;
  content_fr: string;
  content_kab: string | null;
  date: string;
  time: string;
  licence: string | null;
  keyword_1_en: string;
  keyword_1_ar: string;
  keyword_1_fr: string;
  keyword_1_kab: string | null;
  keyword_2_en: string;
  keyword_2_ar: string;
  keyword_2_fr: string;
  keyword_2_kab: string | null;
  keyword_3_en: string;
  keyword_3_ar: string;
  keyword_3_fr: string;
  keyword_3_kab: string | null;
  keyword_4_en: string;
  keyword_4_ar: string;
  keyword_4_fr: string;
  keyword_4_kab: string | null;
  keyword_5_en: string;
  keyword_5_ar: string;
  keyword_5_fr: string;
  keyword_5_kab: string | null;
  created_at_meta: string;
  updated_at_meta: string;
}

const useFetchPosts = () => {
  const { data, error, isLoading, mutate } = useSWR<Post[]>(
    `${process.env.NEXT_PUBLIC_URL}post/`,
    fetcher<Post[]>,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000, // 1 minute
    }
  );

  return { 
    posts: data || [], 
    error, 
    isLoading, 
    mutate // This is the SWR mutate function
  };
};

export default useFetchPosts;